import React from 'react';
import { IoShareOutline } from "react-icons/io5";
import nvgtrLogo_Black from '../../assets/nvgtrLogo_Black.svg';
import nvgtrLogo_White from '../../assets/nvgtrLogo_White.svg';

const PWAPrompt = () => {
  const handleShare = async () => {
    if (!navigator.share) {
      alert('Click the share button in your browsers menu bar, then select "Add to Home Screen"');
      return;
    }

    try {
      await navigator.share({
        title: 'Midus',
        text: 'Check out Midus - your AI-powered business companion!',
        url: window.location.href
      });
      console.log('Shared successfully');
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error sharing:', error);
        alert('To add to home screen:\n1. Tap the share button in your browser\n2. Select "Add to Home Screen"');
      }
    }
  };

  return (
    <div className="fixed inset-0 bg-white dark:bg-[#111111] flex flex-col items-center justify-center px-6 pb-[env(safe-area-inset-bottom)] pt-[calc(env(safe-area-inset-top)+2rem)]">
      <img 
        src={nvgtrLogo_Black} 
        alt="Midus Logo"
        className="h-6 mb-20 dark:hidden"
      />
      <img 
        src={nvgtrLogo_White} 
        alt="Midus Logo"
        className="h-7 mb-20 hidden dark:block"
      />
      
      <div className="text-center max-w-[280px]">
        <h1 className="text-3xl font-semibold mb-3 font-['Poppins'] dark:text-white">
          It's Better in the App.
        </h1>
        
        <p className="text-gray-600 dark:text-gray-300 text-sm mb-6">
          Add Midus to your home screen for the best experience
        </p>

        {/* iOS Share Button */}
        <button 
          onClick={handleShare}
          className="mb-6 p-4 border border-black dark:border-white rounded-full transition-colors dark:text-white"
          aria-label="Open share menu"
        >
          <IoShareOutline className="w-8 h-8" />
        </button>

        <p className="text-sm mb-8 dark:text-gray-300">
            Tap the share button in your browsers menu bar, then scroll to<br /><br />
            <span className="text-black dark:text-white font-semibold">"Add to Home Screen"</span>
          </p>

        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="w-2 h-2 rounded-full bg-gray-500 dark:bg-gray-400"></span>
            Faster access
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
            <span className="w-2 h-2 rounded-full bg-gray-500 dark:bg-gray-400"></span>
            Better performance
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400 mb-6">
            <span className="w-2 h-2 rounded-full bg-gray-500 dark:bg-gray-400"></span>
            Full-screen experience
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWAPrompt; 